import Details from 'components/orders/Details';
import { Card } from 'antd';
import { FinancialIconComponent } from 'assets/icons/financial';
import { IOrder } from 'interfaces/orders';
import { PageHeader } from 'components/professor_area/PageHeader';
import { ShowLayout } from 'components/layout/layout/ShowLayout';
import { useShow } from '@refinedev/core';

export const OrderShow = () => {
  const { queryResult } = useShow<IOrder>();
  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <ShowLayout isLoading={isLoading} title="Visualizar reembolso">
      <PageHeader title="Visualizar reembolso" icon={FinancialIconComponent} />

      <Card>{record && <Details order={record} />}</Card>
    </ShowLayout>
  );
};
